import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { SIASearch, useTranslator } from "@sia/style-guide";
import useCMSSearch from "./useCMSSearch";
import { useParams } from "react-router-dom";
import GlobalContext from "contexts/GlobalContext";

const CMSSearch = () => {
  const { language } = useContext(GlobalContext);
  const { text } = useParams();
  const { mediaItems, videoItems, employeeItems, articlesAndPages, vorstandItems, aliasItems } = useCMSSearch(language, text);
  const history = useHistory();
  const translate = useTranslator();

  useEffect(() => {
    const createBrowserTitle = () => {
      const browserTitle = translate("browser.title");
      if (text) {
        return `${text}  - ${browserTitle}`;
      }
      return browserTitle;
    };
    document.title = createBrowserTitle();
  }, [translate, text]);

  return (
    <SIASearch
      lang={language}
      history={history}
      text={text}
      translate={translate}
      pageItems={articlesAndPages?.filter((el) => el.content_type === "page") || null}
      articleItems={articlesAndPages?.filter((el) => el.content_type === "sia_article") || null}
      vacancyItems={articlesAndPages?.filter((el) => el.content_type === "sia_vacancies") || null}
      mediaItems={mediaItems}
      videoItems={videoItems}
      employeeItems={employeeItems}
      vorstandItems={vorstandItems}
      aliasItems={aliasItems}
    />
  );
};

export default CMSSearch;
